import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { triggerTransition } from '@uirouter/redux';
import { getNumberOfMonths, getVisibleCalendarDays, getCurrentMonth, needsDatesLoaded } from '../../series/selectors/eventSeries';
import { getMainEvent } from '../../../selectors/event';
import SeriesDayPicker from '../../series/components/SeriesDayPicker';
import { setEventTimes, setSelectedDate, handleMonthChange, lazyLoadSeriesDates } from '../../series/actions/event-series';
import { removeListingItem } from '../../../../listing/helpers/storage';
import { deleteReservation } from '../../../actions/reservation';
import { isValidDateObject } from '../../../../helpers/time';
import { reservationActive } from '../../../selectors/reservation';
import KioskLayoutContainer from './KioskLayoutContainer';
import KioskSeriesContainer from './KioskSeriesContainer';
import KioskSeriesHeaderContainer from './KioskSeriesHeaderContainer';
import KioskSeriesContentContainer from './KioskSeriesContentContainer';
import NextAvailableTimeButton from '../../series/components/NextAvailableTimeButton';
import Translation from "../../../../shared/Translation";

class KioskDatePicker extends Component {
    componentDidMount(){
        if(this.props.selectedDate){
            this.getSelectedEventTimes();
        }

        if (needsDatesLoaded(this.props)) {
            this.props.lazyLoadSeriesDates(this.props.currentMonth);
        }
    }


    onDayClick = (day, modifiers = {}) => {
        if (modifiers.disabled) {
            return false;
        }
        this.props.setEventTimes([]);
        removeListingItem(this.props.listingSlug, 'selectedEventId');

        //if user already selected a different date, and there is an active reservation, delete it here
        const pickingSameDay = isValidDateObject(day) && isValidDateObject(this.props.selectedDateObject) && day.getTime() === this.props.selectedDateObject.getTime();
        if (this.props.reservationActive && (!isValidDateObject(this.props.selectedDateObject) || !pickingSameDay)) {
            this.props.deleteReservation(false).then(() => {
                this.getSelectedEventTimes(day);
            });
        } else {
            this.getSelectedEventTimes(day);
        }

    };

    getSelectedEventTimes = (day) => {
        this.props.setSelectedDate(day).then(() => {
            if (day) {
              this.props.triggerTransition('kioskTimePicker');
            }
        });
    }

    onMonthChange = (inputMonth) => {
        const month = new Date(inputMonth.getTime() - inputMonth.getTimezoneOffset() * 60000);
        this.props.handleMonthChange(month);
    };

    render() {
        return (
            <KioskLayoutContainer>
                <div className="kiosk__body--full kiosk__body--transparent">
                    <NextAvailableTimeButton />
                    <KioskSeriesContainer>
                        <KioskSeriesHeaderContainer>
                          <Translation>{'checkout__kiosk_select_date'}</Translation>
                        </KioskSeriesHeaderContainer>
                        <KioskSeriesContentContainer>
                            <SeriesDayPicker
                                selectedDay={this.props.selectedDate}
                                onDayClick={this.onDayClick}
                                onMonthChange={this.onMonthChange}
                            />
                        </KioskSeriesContentContainer>
                    </KioskSeriesContainer>
                </div>
            </KioskLayoutContainer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        eventId: getMainEvent(state)?.event?.event_id,
        numberOfMonths: getNumberOfMonths(state),
        selectedDateObject: state.eventSeries.selectedDateObject,
        selectedDate: state.eventSeries.selectedDate,
        reservationActive: reservationActive(state),
        listingSlug: state.ui.listingSlug,
        currentMonth: getCurrentMonth(state),
        loadedDates: state.eventSeries.datesLazyLoaded,
        needsDatesLoaded: needsDatesLoaded(state),
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setEventTimes,
        setSelectedDate,
        triggerTransition,
        deleteReservation,
        handleMonthChange,
        lazyLoadSeriesDates
    }, dispatch);
};

KioskDatePicker.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(KioskDatePicker)
